"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![CheckboxIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB3aGl0ZTsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHRpdGxlPkNoZWNrYm94PC90aXRsZT4KICA8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KICAgIDxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+CiAgICAgIDxnPgogICAgICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE2LDBIMUExLDEsMCwwLDAsMCwxVjE2YTEsMSwwLDAsMCwxLDFIMTZhMSwxLDAsMCwwLDEtMVYxQTEsMSwwLDAsMCwxNiwwWm0wLDE2SDFWMUgxNloiLz4KICAgICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01LjI5LDEzLjA4YS43NS43NSwwLDAsMCwxLjA2LDBMMTQuNDUsNWEuNzUuNzUsMCwwLDAtMS4wNi0xLjA2TDUuODIsMTEuNDksMy42MSw5LjI4YS43NS43NSwwLDAsMC0xLjA2LDAsLjc0Ljc0LDAsMCwwLDAsMS4wNloiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.CheckboxIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 17 17", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M16 0H1a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm0 16H1V1h15z" }),
        React.createElement("path", { d: "M5.29 13.08a.75.75 0 0 0 1.06 0L14.45 5a.75.75 0 0 0-1.06-1.06l-7.57 7.55-2.21-2.21a.75.75 0 0 0-1.06 0 .74.74 0 0 0 0 1.06z" })));
};
//# sourceMappingURL=Icon.Checkbox.js.map